import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';
import { addQueryParameters } from '../utils/url';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/businesses`,
  CREATE: `${apiUrlConfig.apiEndPoint()}/businesses`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/businesses/:id`,
  UPDATE: `${apiUrlConfig.apiEndPoint()}/businesses/:id`,
  DELETE: `${apiUrlConfig.apiEndPoint()}/businesses/:id`,
  SURVEY_EMAIL_REPORT_CONFIGS: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/survey_email_report_configs`,
  COMMENT_EMAIL_REPORT_CONFIGS: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/comment_email_report_configs`,
  SMS_ALERT_CONFIGS: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/sms_alert_configs`,
  SUGGESTED_SURVEYS: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/suggested_templates`,
  BILLING_ACTIVITY: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/payment_logs`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

function insertBusinessIdToUrl(url, id) {
  return url.replace(':business_id', id);
}

class BusinessApi {
  /**
   * add new business
   */
  static addNew(data) {
    return AuthenticatedRequestService.post(URLS.CREATE, data);
  }

  /**
   * gets all businesses
   */
  static getAll() {
    return AuthenticatedRequestService.get(URLS.INDEX);
  }

  /**
   * get business details
   */
  static getDetails(businessId) {
    const SHOW_URL = insertIdToUrl(URLS.SHOW, businessId);

    return AuthenticatedRequestService.get(SHOW_URL);
  }

  /**
   * updates business
   */
  static update(businessId, data, password) {
    const UPDATE_URL = insertIdToUrl(URLS.UPDATE, businessId);
    const URL = addQueryParameters(UPDATE_URL, { password });
    return AuthenticatedRequestService.patch(URL, data);
  }

  /**
   * deletes business
   */
  static delete(businessId) {
    const DELETE_URL = insertIdToUrl(URLS.DELETE, businessId);

    return AuthenticatedRequestService.delete(DELETE_URL);
  }

  /**
   * get suggested templates
   */
  static getSuggestedSurvey(businessId) {
    const SHOW_URL = insertBusinessIdToUrl(URLS.SUGGESTED_SURVEYS, businessId);

    return AuthenticatedRequestService.get(SHOW_URL);
  }

  // TODO remove this
  static getBusinessEmailReportConfig(businessId) {
    const EMAIL_REPORT_CONFIG_URL = insertBusinessIdToUrl(
      URLS.SURVEY_EMAIL_REPORT_CONFIGS,
      businessId
    );

    return AuthenticatedRequestService.get(EMAIL_REPORT_CONFIG_URL);
  }

  static getBusinessSurveyEmailReportConfigs(businessId) {
    const SURVEY_EMAIL_REPORT_CONFIG_URL = insertBusinessIdToUrl(
      URLS.SURVEY_EMAIL_REPORT_CONFIGS,
      businessId
    );

    return AuthenticatedRequestService.get(SURVEY_EMAIL_REPORT_CONFIG_URL);
  }

  static getBusinessCommentEmailReportConfig(businessId) {
    const COMMENT_EMAIL_REPORT_CONFIG_URL = insertBusinessIdToUrl(
      URLS.COMMENT_EMAIL_REPORT_CONFIGS,
      businessId
    );

    return AuthenticatedRequestService.get(COMMENT_EMAIL_REPORT_CONFIG_URL);
  }

  static getBusinessSmsConfig(businessId) {
    const SMS_ALERT_CONFIG_URL = insertBusinessIdToUrl(
      URLS.SMS_ALERT_CONFIGS,
      businessId
    );

    return AuthenticatedRequestService.get(SMS_ALERT_CONFIG_URL);
  }

  static updateEmailReportConfig(
    emailReportConfigId,
    email_interval,
    is_active
  ) {
    const UPDATE_EMAIL_REPORT_CONFIG_URL = insertIdToUrl(
      URLS.EMAIL_REPORT_CONFIG_UPDATE,
      emailReportConfigId
    );
    const data = {
      email_report_config: {
        email_interval,
        is_active,
      },
    };

    return AuthenticatedRequestService.patch(
      UPDATE_EMAIL_REPORT_CONFIG_URL,
      data
    );
  }

  /**
   * Fetch billing activity of business
   * @param {int} businessId
   */
  static getBillingActivity(businessId) {
    const INDEX_URL = insertBusinessIdToUrl(URLS.BILLING_ACTIVITY, businessId);
    return AuthenticatedRequestService.get(INDEX_URL);
  }
}

export default BusinessApi;



// WEBPACK FOOTER //
// ./src/apis/Business.js